import React from 'react';
import { motion } from 'framer-motion';
import { SectionHead, CtaButton, SERIF, SCROLL_MT } from './shared';

export default function HowItWorks({ how, onCta }) {
  const steps = (how.steps || []).filter(s => s && s.title);
  if (!steps.length) return null;
  return (
    <section id="how-it-works" className={`${SCROLL_MT} py-12 sm:py-16 lg:py-20`} data-testid="how-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <SectionHead label={how.label} title={how.title} subtitle={how.subtitle} className="mb-8 sm:mb-10" />
        <ol className="grid md:grid-cols-3 gap-4 sm:gap-5 relative" data-testid="how-steps">
          <span className="hidden md:block absolute top-9 left-[16%] right-[16%] h-px bg-gradient-to-r from-amber-300 via-slate-300 to-amber-300" aria-hidden="true" />
          {steps.map((s, i) => (
            <motion.li key={i} initial={{ opacity: 0, y: 26 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: '-60px' }} transition={{ duration: 0.6, delay: i * 0.1 }}
              className="relative flex md:flex-col gap-4 md:gap-0 md:text-center" data-testid={`how-step-${i}`}>
              <span className="relative z-10 shrink-0 mx-0 md:mx-auto w-14 h-14 sm:w-[70px] sm:h-[70px] rounded-2xl bg-slate-900 text-amber-400 flex items-center justify-center text-2xl sm:text-3xl shadow-[0_18px_40px_-18px_rgba(15,23,42,0.7)] ring-8 ring-[#f5f1eb]" style={SERIF}>
                {String(i + 1).padStart(2, '0')}
              </span>
              <div className="flex-1 md:mt-4 rounded-[20px] bg-white border border-neutral-200 px-5 py-4 sm:px-6 sm:py-5 hover:shadow-[0_28px_60px_-30px_rgba(15,23,42,0.35)] hover:-translate-y-0.5 transition-all duration-300 h-full">
                {s.kicker && <p className="text-[11px] font-bold tracking-[0.2em] uppercase text-amber-700 mb-1">{s.kicker}</p>}
                <h3 className="font-[Manrope] font-extrabold text-lg sm:text-xl tracking-[-0.02em] text-slate-900">{s.title}</h3>
                {s.desc && <p className="mt-1.5 text-[14px] sm:text-[14.5px] text-slate-600 leading-relaxed">{s.desc}</p>}
              </div>
            </motion.li>
          ))}
        </ol>
        {how.cta_label && (
          <div className="mt-8 sm:mt-10 text-center">
            <CtaButton label={how.cta_label} onClick={() => onCta('how_it_works')} variant="dark" size="md" className="w-full sm:w-auto" testId="how-cta" />
          </div>
        )}
      </div>
    </section>
  );
}
